<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    shopping_cart
                </mat-icon>
                <span>
                    Product: {{ itemEnvelope?.Document?.Item?.Name }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                Edit Product: {{ itemEnvelope?.Document?.Item?.ProductId }} - {{ itemEnvelope?.Document?.Item?.Name }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="flex-direction-vertical flex-container-basic">
                <mat-form-field appearance="outline" class="responsive-width">
                    <mat-label>Name</mat-label>
                    <input *ngIf="itemEnvelope" matInput name="Name" placeholder="Name" [(ngModel)]="$any(itemEnvelope).Document.Item.Name" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Description</mat-label>
                    <input *ngIf="itemEnvelope" matInput name="Description" placeholder="Description" [(ngModel)]="$any(itemEnvelope).Document.Item.Description" />
                </mat-form-field>
            </div>
            <mat-tab-group>
                <br />
                <mat-tab label="Details">
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

